// /home/szymon/kreator2/frontend/src/components/ClientOrderPanel.js
// v14.3.0 – Ujednolicenie logicznego miejsca przechowywania personalizacja z kodem Edytora.

import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Pencil, Check, X, Info, AlertTriangle, CheckCircle, Search, PlusCircle, Trash2, Send, HelpCircle, Save, Mail } from "lucide-react"; // Dodano Save i Mail
import { Tooltip } from 'react-tooltip';
import "./ClientOrderPanel.css";
import Popup from './common/Popup';
import { useClientOrderData } from '../hooks/useClientOrderData';
import { useClientOrderActions } from '../hooks/useClientOrderActions'; // Import nowego hooka
import ClientProjectTable from './ClientProjectTable';
import AddProjectFromTemplateSection from './AddProjectFromTemplateSection';
import SendToPrintPopup from './SendToPrintPopup'; // Import nowego komponentu popupa
import EditorOverlayWrapper from './EditorOverlayWrapper'; // Import komponentu EditorOverlayWrapper
import ClientProjectSupportPopup from './ClientProjectSupportPopup'; // NOWY IMPORT
import AiProcessingOverlay from './common/AiProcessingOverlay'; // NOWY IMPORT
// import LoadingSpinner from './LoadingSpinner';


/**
 * Komponent do panelu klienta (zamówienie).
 */
export default function ClientOrderPanel({ backendUrl, tooltipsEnabled = true, setTooltipsEnabled }) {
  const { publicKey } = useParams();
  const navigate = useNavigate();

  // Stan dla tooltipów (jeśli nie jest przekazany z zewnątrz)
  const [localTooltipsEnabled, setLocalTooltipsEnabled] = useState(true);

  // Używamy przekazanych propsów lub lokalnego stanu
  const tooltipsEnabledValue = tooltipsEnabled !== undefined ? tooltipsEnabled : localTooltipsEnabled;
  const setTooltipsEnabledValue = setTooltipsEnabled || setLocalTooltipsEnabled;

  // Funkcja pomocnicza do generowania propsów tooltipa
  const tooltipProps = (content) => {
    return tooltipsEnabledValue ? { "data-tooltip-id": "client-panel-tooltip", "data-tooltip-content": content } : {};
  };

  // Stan dla konfiguracji popupa
  const [popupConfig, setPopupConfig] = useState(null); // null | { title?, message, type?, onConfirm?, onCancel?, confirmText?, cancelText? }

  // --- Funkcje pomocnicze do obsługi popupa ---
  const showPopup = useCallback((config) => setPopupConfig(config), []); // useCallback dla showPopup
  const hidePopup = () => setPopupConfig(null);

  // Użycie hooka do pobierania danych
  const {
    order,
    setOrder, // Potrzebne do aktualizacji po akcjach
    isLoading,
    statuses,
    statusesLoading, // Można usunąć, jeśli isLoading z hooka wystarczy
    templates,
    templatesLoading, // Można usunąć, jeśli isLoading z hooka wystarczy
    personalizationAvailability,
    personalizationLoading, // Można usunąć, jeśli isLoading z hooka wystarczy
    fetchOrder // Do odświeżania
  } = useClientOrderData(backendUrl, publicKey, showPopup);

  // Stany do edycji nazwy PLIKU w tabeli
  const [editingFileId, setEditingFileId] = useState(null); // ID pliku w trybie edycji nazwy
  const [tempFileName, setTempFileName] = useState(""); // Tymczasowa nazwa pliku
  // Stan dla śledzenia aktualizacji ilości (pozostaje)
  const [updatingQuantityFileId, setUpdatingQuantityFileId] = useState(null); // ID pliku, którego ilość jest aktualizowana

  // Stany do edycji listy gości (przywrócone)
  const [guestsOpenMap, setGuestsOpenMap] = useState({});
  const [guestsTextMap, setGuestsTextMap] = useState({});
  const [guestsLoadingFileId, setGuestsLoadingFileId] = useState(null); // Nadal potrzebne do textarea
  const [guestEditAreaVisibleMap, setGuestEditAreaVisibleMap] = useState({}); // NOWY STAN

  // Usunięto confirmOverwrite, będzie obsługiwane przez popup
  // const [confirmOverwrite, setConfirmOverwrite] = useState(null);
  const [duplicatingFileId, setDuplicatingFileId] = useState(null); // Stan do śledzenia duplikowania
  const [deletingFileId, setDeletingFileId] = useState(null); // Stan do śledzenia usuwania
  // Stany personalizationAvailability i personalizationLoading są teraz w hooku useClientOrderData

  // Stany dla sekcji dodawania projektu z szablonu
  // Stany templates, templatesLoading i templateSearchQuery są teraz zarządzane w AddProjectFromTemplateSection lub hooku
  const [addingProjectFromTemplateId, setAddingProjectFromTemplateId] = useState(null); // ID szablonu w trakcie dodawania

  // Stan do kontrolowania widoczności nowego popupa
  const [showSendToPrintPopup, setShowSendToPrintPopup] = useState(false);
  // Stany sendEmail, isSendingToPrint, sendPopupValidationError, sendNoteRef są teraz w SendToPrintPopup

  // Użycie useRef zamiast useState dla pola komentarza, aby uniknąć zbędnych renderowań
  // const sendNoteRef = useRef(""); // Przeniesione do SendToPrintPopup

  // Stan do śledzenia ładowania dla przycisku "Zapisz i wyślij link"
  const [isSavingAndSendingLink, setIsSavingAndSendingLink] = useState(false);
  
  // Stany do obsługi EditorOverlayWrapper
  const [showEditorOverlay, setShowEditorOverlay] = useState(false);
  const [editorOverlayProps, setEditorOverlayProps] = useState(null);

  // Stany dla popupa "Poproś o zmiany"
  const [showSupportPopupForFile, setShowSupportPopupForFile] = useState(null); // Przechowuje obiekt fileObj
  const [supportOption, setSupportOption] = useState(''); // 'graphic' lub 'ai'
  // const [supportClientRequestText, setSupportClientRequestText] = useState(''); // Przeniesione do ClientProjectSupportPopup
  // const [supportClientEmail, setSupportClientEmail] = useState(''); // Przeniesione do ClientProjectSupportPopup
  const [isSupportRequestLoading, setIsSupportRequestLoading] = useState(false);
  const [supportStatusMessage, setSupportStatusMessage] = useState({ type: '', text: '' });
  const [currentHistoryIdForSupport, setCurrentHistoryIdForSupport] = useState(null);
  const [aiModifiedHistoryIdForSupport, setAiModifiedHistoryIdForSupport] = useState(null);
  const [previousVersionIdForAiSupport, setPreviousVersionIdForAiSupport] = useState(null);
  const [isAiSupportProcessing, setIsAiSupportProcessing] = useState(false); // Dla AiProcessingOverlay

  // Użycie hooka do obsługi akcji
  const actions = useClientOrderActions(
    backendUrl,
    publicKey,
    order,
    setOrder,
    showPopup,
    hidePopup,
    guestsTextMap, // Przekazanie mapy tekstów gości
    guestsTextMap // Przekazanie mapy tekstów gości
    // sendNoteRef // Już niepotrzebne, zarządzane w SendToPrintPopup
  );

  // --- Obsługa edycji nazwy PLIKU (pozostaje w komponencie, bo zarządza lokalnym stanem edycji) ---

  // Rozpoczyna edycję nazwy pliku
  const handleEditFileNameClick = (fileObj) => {
    setEditingFileId(fileObj.id);
    setTempFileName(fileObj.fileName);
  };

  // Anuluje edycję nazwy pliku
  const handleCancelEditFileName = () => {
    setEditingFileId(null);
    setTempFileName(""); // Czyścimy tymczasową nazwę
  };

  // Zapisuje nową nazwę pliku
  const handleSaveFileName = useCallback(async () => {
    if (!editingFileId || !order) return;

    const newName = tempFileName.trim();
    const originalFile = order.files.find(f => f.id === editingFileId);

    if (!originalFile || newName === "") {
        handleCancelEditFileName(); // Anuluj, jeśli pusta nazwa
        return;
    }

    // Sprawdź, czy oryginalny plik był PDF i czy nowa nazwa ma rozszerzenie
    const originalWasPdf = originalFile.fileName.toLowerCase().endsWith('.pdf');
    let finalNewName = newName;
    if (originalWasPdf && !newName.toLowerCase().endsWith('.pdf')) {
        finalNewName += '.pdf'; // Dodaj rozszerzenie, jeśli brakuje
    }

    // Anuluj, jeśli nazwa (z ewentualnym dodanym .pdf) jest taka sama jak oryginał
    if (finalNewName === originalFile.fileName) {
        handleCancelEditFileName();
        return;
    }


    // setError(""); // Już niepotrzebne
    try {
      // Przygotuj nową tablicę plików z finalną nazwą
      const updatedFiles = order.files.map(file =>
        file.id === editingFileId ? { ...file, fileName: finalNewName } : file
      );

      const url = `${backendUrl}/client/orders/${publicKey}`; // Używamy ogólnego endpointu PATCH
      console.log("[ClientOrderPanel] handleSaveFileName => PATCH =>", url);
      const res = await fetch(url, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        // Wysyłamy całą zaktualizowaną tablicę plików
        body: JSON.stringify({ files: updatedFiles })
      });

      if (!res.ok) {
        throw new Error(`Błąd zapisu nazwy pliku (status=${res.status})`);
      }

      const result = await res.json();
      console.log("[ClientOrderPanel] handleSaveFileName => result=", result);

      // Aktualizuj stan lokalny nową tablicą plików zwróconą z backendu (jeśli jest)
      // lub użyj tej, którą wysłaliśmy
      setOrder(prevOrder => ({
        ...prevOrder,
        files: result.files || updatedFiles // Preferuj odpowiedź serwera
      }));

      handleCancelEditFileName(); // Zakończ edycję
      // alert("Nazwa pliku została zaktualizowana.");
      showPopup({ message: "Nazwa pliku została zaktualizowana.", type: 'success' });

    } catch (err) {
      console.error("[ClientOrderPanel] handleSaveFileName =>", err);
      // setError("Nie udało się zapisać nowej nazwy pliku.");
      showPopup({ title: "Błąd zapisu", message: "Nie udało się zapisać nowej nazwy pliku.", type: 'error' });
      // Można zostawić otwarte pole edycji w razie błędu
    }
  }, [backendUrl, order, publicKey, editingFileId, tempFileName, setOrder, showPopup]);


  // --- Koniec obsługi edycji nazwy PLIKU ---

  // Usunięto funkcje obsługi trybu edycji ilości (handleEditQuantityClick, handleCancelEditQuantity, handleSaveQuantity)
  // Zapis odbywa się teraz przez debouncing w QuantityCell, który wywołuje actions.updateQuantity

  // Usunięto useEffect do pobierania statusów - obsługiwane przez hook
  // Usunięto funkcje handleEditNameClick, handleCancelEditName, handleSaveOrderName

  // Otwiera edytor
  const handleOpenEditor = (downloadKey) => {
    console.log("[handleOpenEditor] =>", downloadKey);
    navigate(`/client/orders/${publicKey}/pdf-editor/${downloadKey}`);
  };

  // Usunięto handlePreviewPdf - przeniesione do useClientOrderActions
  // Usunięto findPersonalizePageIndex - przeniesione do useClientOrderActions

  const handleOpenSupportPopup = async (fileObj) => {
    console.log('[ClientOrderPanel] handleOpenSupportPopup called with fileObj:', fileObj); // LOG 1
    setShowSupportPopupForFile(fileObj);
    console.log('[ClientOrderPanel] showSupportPopupForFile should be set to:', fileObj); // LOG 2
    setSupportOption('');
    // setSupportClientRequestText(''); // Już niepotrzebne, zarządzane w popupie
    setSupportStatusMessage({ type: '', text: '' }); // Resetuj status przy otwarciu
    setAiModifiedHistoryIdForSupport(null);
    setPreviousVersionIdForAiSupport(null);
    // setSupportClientEmail(order?.customOrderId || ''); // Już niepotrzebne, zarządzane w popupie, który dostaje orderEmail

    // Pobierz najnowszą historię dla tego pliku
    if (fileObj && fileObj.downloadKey) {
      try {
        // Zakładamy, że actions.fetchLatestHistoryId zostanie dodane do useClientOrderActions
        console.log('[ClientOrderPanel] Fetching latest history ID for downloadKey:', fileObj.downloadKey); // LOG 3
        const historyData = await actions.fetchLatestHistoryId(fileObj.downloadKey);
        console.log('[ClientOrderPanel] Fetched historyData:', historyData); // LOG 4
        if (historyData && historyData.newestId) {
          setCurrentHistoryIdForSupport(historyData.newestId);
          if (historyData.jsonData?.aiPreviousVersionId) {
            setPreviousVersionIdForAiSupport(historyData.jsonData.aiPreviousVersionId);
          } else if (historyData.jsonData?.parentHistoryIdForAi) { // Fallback
            setPreviousVersionIdForAiSupport(historyData.jsonData.parentHistoryIdForAi);
          }
        } else {
          setCurrentHistoryIdForSupport(null);
          setPreviousVersionIdForAiSupport(null);
        }
      } catch (error) {
        console.error("Błąd pobierania historii dla popupa wsparcia:", error);
        setSupportStatusMessage({ type: 'error', text: 'Nie można załadować informacji o historii projektu.' });
        setCurrentHistoryIdForSupport(null);
        setPreviousVersionIdForAiSupport(null);
      }
    }
  };

  const handleCloseSupportPopup = () => {
    setShowSupportPopupForFile(null);
    // Reset stanów popupa
    setSupportOption('');
    // setSupportClientRequestText(''); // Już niepotrzebne
    setSupportStatusMessage({ type: '', text: '' });
    setCurrentHistoryIdForSupport(null);
    setAiModifiedHistoryIdForSupport(null);
    setPreviousVersionIdForAiSupport(null);
  };

  const handleSendSupportRequest = async (requestText, emailForGraphic) => { // Dodano argumenty
    if (!showSupportPopupForFile || !supportOption) return;
    if (!requestText.trim()) {
      setSupportStatusMessage({ type: 'error', text: 'Wpisz treść prośby.' });
      return;
    }

    setIsSupportRequestLoading(true);
    if (supportOption === 'ai') {
      setIsAiSupportProcessing(true);
    }
    setSupportStatusMessage({ type: '', text: '' });

    const { downloadKey, id: fileId } = showSupportPopupForFile;

    try {
      let result;
      if (supportOption === 'graphic') {
        if (!emailForGraphic.trim() || !emailForGraphic.includes('@')) { // Użyj emailForGraphic
          setSupportStatusMessage({ type: 'error', text: 'Podaj poprawny adres email do kontaktu.' });
          setIsSupportRequestLoading(false);
          return;
        }
        result = await actions.requestGraphicChanges(downloadKey, requestText, emailForGraphic); // Użyj requestText, emailForGraphic
      } else if (supportOption === 'ai') {
        if (!currentHistoryIdForSupport) {
          setSupportStatusMessage({ type: 'error', text: 'Nie można zidentyfikować aktualnej wersji projektu dla AI.' });
          setIsSupportRequestLoading(false);
          setIsAiSupportProcessing(false);
          return;
        }
        result = await actions.aiModifyProject(downloadKey, requestText, currentHistoryIdForSupport, setIsAiSupportProcessing); // Użyj requestText
        if (result.success && result.newHistoryId) {
          setAiModifiedHistoryIdForSupport(result.newHistoryId);
          setCurrentHistoryIdForSupport(result.newHistoryId);
          setPreviousVersionIdForAiSupport(currentHistoryIdForSupport);
        }
      }

      if (result && result.success) {
        setSupportStatusMessage({ type: 'success', text: result.message + (result.message.includes("Prośba została wysłana") ? "" : " Prośba została wysłana.") }); // Dodajemy info o wysłaniu, jeśli nie ma
        // setSupportClientRequestText(''); // Już niepotrzebne, zarządzane w popupie
        if (supportOption === 'ai' && result.newHistoryId) {
           fetchOrder();
        } else if (supportOption === 'graphic') {
          // Można rozważyć zamknięcie popupa po sukcesie
          // setTimeout(handleCloseSupportPopup, 2000);
        }
      } else {
        throw new Error(result?.message || 'Wystąpił nieoczekiwany błąd.');
      }
    } catch (error) {
      setSupportStatusMessage({ type: 'error', text: error.message || 'Nie udało się wysłać prośby.' });
    } finally {
      setIsSupportRequestLoading(false);
      if (supportOption === 'ai') {
         if (typeof setIsAiSupportProcessing === 'function') setIsAiSupportProcessing(false);
      }
    }
  };

  const handleRestoreAiVersionSupport = async () => {
    if (!showSupportPopupForFile || !previousVersionIdForAiSupport) return;

    setIsSupportRequestLoading(true);
    setSupportStatusMessage({ type: '', text: '' });
    const { downloadKey } = showSupportPopupForFile;

    try {
      // Zakładamy, że actions.restoreAiModifiedVersion zostanie dodane
      const result = await actions.restoreAiModifiedVersion(downloadKey, previousVersionIdForAiSupport);
      if (result.success) {
        setSupportStatusMessage({ type: 'success', text: result.message + " Odświeżanie..." });
        setAiModifiedHistoryIdForSupport(null); // Wersja AI nie jest już "aktywna"
        setPreviousVersionIdForAiSupport(null); // Nie ma już "poprzedniej" wersji AI do której można wrócić z tego miejsca
        setCurrentHistoryIdForSupport(result.newHistoryId); // Ustawiamy przywróconą jako aktualną
        fetchOrder(); // Odśwież dane
        // setTimeout(handleCloseSupportPopup, 2000); // Zamknij popup po chwili
      } else {
        throw new Error(result.message || 'Nie udało się przywrócić wersji.');
      }
    } catch (error) {
      setSupportStatusMessage({ type: 'error', text: error.message });
    } finally {
      setIsSupportRequestLoading(false);
    }
  };

  // Usunięto handleFetchGuestsForFile - przeniesione do useClientOrderActions
  // Usunięto handleSaveGuestsForFile - przeniesione do useClientOrderActions
  // Usunięto handleGeneratePersonalizedProject - przeniesione do useClientOrderActions
  // Usunięto doGeneratePersonalized - przeniesione do useClientOrderActions

  // Usunięto handleDuplicateProject - przeniesione do useClientOrderActions
  // Usunięto handleAddProjectFromTemplate - przeniesione do useClientOrderActions
  // Usunięto handleDeleteProject - przeniesione do useClientOrderActions
  // Usunięto doDeleteProject - przeniesione do useClientOrderActions

  // --- Funkcja do zarządzania stanem otwarcia edytora listy gości ---
  const handleToggleGuests = (fileId, willBeOpen) => {
    setGuestsOpenMap(prev => ({ ...prev, [fileId]: willBeOpen }));
    // Jeśli otwieramy edycję, upewnijmy się, że pole jest widoczne
    if (willBeOpen) {
      setGuestEditAreaVisibleMap(prev => ({ ...prev, [fileId]: true }));
    }
  };

  // --- Callback po pomyślnym zapisie listy gości ---
  const handleGuestSaveSuccess = (fileId) => {
    setGuestEditAreaVisibleMap(prev => ({ ...prev, [fileId]: false }));
    // Zamknij również panel edycji gości, aby przycisk się zaktualizował
    setGuestsOpenMap(prev => ({ ...prev, [fileId]: false }));
  };

  // --- Funkcja otwierająca popup wysyłki do druku ---
  const handleOpenSendPopup = () => {
    // Wywołanie funkcji z hooka useClientOrderActions, która pobierze email i otworzy popup
    // (Nie potrzebujemy już przekazywać setterów tutaj, bo SendToPrintPopup zarządza swoim stanem)
    setShowSendToPrintPopup(true); // Po prostu pokazujemy komponent SendToPrintPopup
  };

  // --- Obsługa sukcesu wysłania do druku ---
  const handleSendSuccess = (updatedOrderData) => {
    setOrder(updatedOrderData); // Aktualizuj stan zamówienia
    // Pokaż generyczny popup sukcesu (opcjonalnie, bo SendToPrintPopup może to robić)
    showPopup({
      title: "Wysłano do druku!",
      message: "Zamówienie zostało zaakceptowane i przekazane do realizacji. Sprawdź swoją pocztę e-mail.",
      type: 'success'
    });
  };

  // --- Koniec obsługi sukcesu wysłania do druku ---


  // Usunięto renderowanie błędu, bo obsługuje go popup
  // if (error) { ... }

  // Obliczamy, czy całe zamówienie jest już wysłane do druku
  const isOrderSentToPrint = useMemo(() => {
    if (!order) {
      return false; // Jeśli nie ma zamówienia, nie jest wysłane
    }
    // Sprawdzamy, czy zamówienie ma flagę sentToPrint
    return !!order.sentToPrint;
  }, [order]);

  // Obliczamy, czy wszystkie projekty są zaakceptowane
  const areAllProjectsAccepted = useMemo(() => {
    if (!order || !order.files || order.files.length === 0) {
      return false; // Jeśli nie ma plików, nie są zaakceptowane
    }
    // Sprawdź, czy KAŻDY plik ma statusId = 1 (zakładamy, że 1 to 'Zaakceptowany')
    return order.files.every(f => f.statusId === 1);
  }, [order]);

  // Usunięto stary warunek (!order), teraz obsługiwane przez isLoading
  // if (!order) { ... }

  const visibleFiles = (order?.files || []).filter((f) => !f._prod); // Dodano ?. dla bezpieczeństwa

  // Usunięto isPanelLoading, używamy bezpośrednio isLoading z hooka
  // const isPanelLoading = isLoading || statusesLoading || templatesLoading || personalizationLoading;

  // Dodajemy stan do śledzenia, czy komponent został zamontowany
  const [isMounted, setIsMounted] = useState(false);

  // Ustawiamy isMounted na true po zamontowaniu komponentu
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  return (
    // Zmieniamy strukturę: najpierw overlay, potem kontener z zawartością
    <>
      {/* Nakładka ładowania - używamy isLoading z hooka */}
      {isLoading && !popupConfig && !showSendToPrintPopup && (
        <div className="client-panel-loading-overlay">
          {/* Zaktualizowany spinner (Bouncing Dots) */}
          <div className="client-panel-spinner">
            <div className="dot1"></div>
            <div className="dot2"></div>
            <div></div> {/* Trzecia kropka */}
          </div>
          <p>Ładowanie danych zamówienia...</p>
        </div>
      )}

      {/* Kontener panelu - widoczny zawsze, ale zawartość renderowana warunkowo */}
      <div className="client-panel-container" style={{ filter: isMounted && !isLoading ? 'none' : 'blur(0px)' }}>
      {/* Główna zawartość panelu - używamy isLoading z hooka */}
      {!isLoading && order && (
        <>
          {/* Usunięto logikę edycji nazwy zamówienia, wyświetlamy tylko nazwę */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <h2 className="client-panel-title">
                Zamówienie: {order.orderName}
              </h2>

              {/* Przełącznik tooltipów */}
              <div style={{ display: 'flex', alignItems: 'center' }} title={tooltipsEnabledValue ? "Wyłącz podpowiedzi" : "Włącz podpowiedzi"}>
                <span style={{ fontSize: '13px', color: '#4a5568', marginRight: '5px' }}>Podpowiedzi:</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={tooltipsEnabledValue}
                    onChange={() => setTooltipsEnabledValue(!tooltipsEnabledValue)}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
            <p className="client-panel-subtitle">E-mail: {order.customOrderId || "-"}</p>

      {/* Przycisk "Wyślij do druku" - dodany tutaj */}
      <div className="client-panel-main-action">
        <button
          className={`client-btn client-btn-send-print ${isOrderSentToPrint ? 'client-btn-sent' : ''}`}
          onClick={handleOpenSendPopup}
          disabled={isOrderSentToPrint} // Wyłączony tylko, jeśli już wysłane do druku
          {...tooltipProps("Kliknij, aby wysłać całe zamówienie do realizacji. Przed realizacją sprawdzimy zamówienie i skontaktujemy się z Tobą.  Wszystkie projekty zostaną oznaczone jako zaakceptowane.")}
        >
          <Send size={18} style={{ marginRight: '8px' }} />
          {isOrderSentToPrint ? "Zamówienie przekazane do druku" : "Wyślij całość do druku"}
        </button>
        {isOrderSentToPrint && (
           <p style={{marginTop: '5px', color: 'green', fontSize: '0.9em'}}>Twoje zamówienie zostało przekazane do realizacji. Wkrótce skontaktujemy się z Tobą, aby potwierdzić szczegóły.</p>
        )}
        {/* Dodajemy nowy przycisk obok "Wyślij do druku" */}
        <button
          className={`client-btn client-btn-save-link ${isSavingAndSendingLink ? 'client-btn-loading' : ''}`}
          onClick={() => handleSaveAndSendLink()} // Wywołujemy nową funkcję
          disabled={isSavingAndSendingLink || isOrderSentToPrint} // Wyłączony podczas ładowania lub gdy zamówienie wysłane
          {...tooltipProps("Zapisuje aktualny stan projektów i wysyła Ci link do tego panelu na Twój adres e-mail.")}
        >
          {isSavingAndSendingLink ? (
            <>
              <div className="client-panel-spinner client-panel-spinner-button">
                <div className="dot1"></div><div className="dot2"></div><div></div>
              </div>
              <span>Wysyłanie...</span>
            </>
          ) : (
            <>
              <Save size={18} style={{ marginRight: '8px' }} />
              Zapisz i wyślij mi link
            </>
          )}
        </button>
      </div>

      <h3 className="client-panel-section-title">Projekty w zamówieniu</h3>
      {visibleFiles.length === 0 ? (
        <p className="client-panel-no-files">Brak plików w tym zamówieniu.</p>
      ) : (
        <ClientProjectTable
          files={visibleFiles}
          statuses={statuses}
          personalizationAvailability={personalizationAvailability}
          editingFileId={editingFileId}
          tempFileName={tempFileName}
          setTempFileName={setTempFileName}
          // Usunięto propsy związane z trybem edycji ilości
          updatingQuantityFileId={updatingQuantityFileId} // Przekazujemy stan ładowania
          guestsOpenMap={guestsOpenMap}
          guestsTextMap={guestsTextMap}
          setGuestsTextMap={setGuestsTextMap}
          guestsLoadingFileId={guestsLoadingFileId}
          guestEditAreaVisibleMap={guestEditAreaVisibleMap} // Przekazanie nowego stanu
          duplicatingFileId={duplicatingFileId}
          deletingFileId={deletingFileId}
          tooltipProps={tooltipProps}
          onEditFileNameClick={handleEditFileNameClick}
          onCancelEditFileName={handleCancelEditFileName}
          onSaveFileName={handleSaveFileName}
          onUpdateQuantity={(fileId, quantity) => actions.updateQuantity(fileId, quantity, setUpdatingQuantityFileId)} // Przekazujemy funkcję z hooka i setter stanu ładowania
          // Pozostałe propsy
          onOpenEditor={handleOpenEditor}
          onPreviewPdf={(downloadKey) => actions.previewPdf(downloadKey, setShowEditorOverlay, setEditorOverlayProps)}
          onToggleGuests={handleToggleGuests}
          onFetchGuests={(fileObj) => actions.fetchGuests(fileObj, setGuestsLoadingFileId, setGuestsTextMap)}
          onSaveGuests={(fileObj) => actions.saveGuests(fileObj, setGuestsLoadingFileId, handleGuestSaveSuccess)} // Przekazanie callbacku
          onGeneratePersonalized={actions.generatePersonalized}
          onDuplicateProject={(fileObj) => actions.duplicateProject(fileObj, setDuplicatingFileId)}
          onDeleteProject={(fileObj) => actions.deleteProject(fileObj, setDeletingFileId)}
          onOpenSupportPopup={handleOpenSupportPopup} // Przekazanie nowej funkcji
        />
      )}

      {/* Sekcja dodawania projektu z szablonu - użycie nowego komponentu */}
      <AddProjectFromTemplateSection
        templates={templates} // Z hooka useClientOrderData
        templatesLoading={templatesLoading} // Z hooka useClientOrderData
        onAddProject={(templateId) => actions.addProjectFromTemplate(templateId, setAddingProjectFromTemplateId)} // Użycie funkcji z hooka i przekazanie settera
        addingProjectFromTemplateId={addingProjectFromTemplateId}
        tooltipProps={tooltipProps}
      />

      {/* Renderowanie nowego komponentu SendToPrintPopup */}
      <SendToPrintPopup
        isOpen={showSendToPrintPopup}
        onClose={() => setShowSendToPrintPopup(false)}
        backendUrl={backendUrl}
        publicKey={publicKey}
        initialEmail={order?.customOrderId || ""}
        onSuccess={handleSendSuccess} // Przekazanie callbacku sukcesu
      />
      
      {/* Renderowanie EditorOverlayWrapper, gdy jest potrzebny */}
      {showEditorOverlay && editorOverlayProps && (
        <EditorOverlayWrapper {...editorOverlayProps} />
      )}

      {/* Renderowanie generycznego popupa (pozostaje bez zmian) */}
      {popupConfig && (typeof popupConfig === 'object') && (popupConfig.message || popupConfig.title) && (
        <Popup config={popupConfig} onClose={hidePopup} />
      )}

      {/* Popup "Poproś o zmiany" */}
      {console.log("[ClientOrderPanel] Rendering. showSupportPopupForFile:", showSupportPopupForFile)}
      {showSupportPopupForFile && (
        <ClientProjectSupportPopup // Załóżmy, że ten komponent zostanie stworzony
          isOpen={!!showSupportPopupForFile}
          file={showSupportPopupForFile}
          orderEmail={order?.customOrderId || ''} // Przekazujemy email zamówienia do inicjalizacji w popupie
          onClose={handleCloseSupportPopup}
          onSubmitRequest={handleSendSupportRequest} // Ta funkcja teraz przyjmie tekst i email z popupa
          onRestoreVersion={handleRestoreAiVersionSupport}
          // backendUrl // Już niepotrzebny
          supportOption={supportOption}
          setSupportOption={setSupportOption}
          // clientRequestText i settery usunięte
          // clientEmail i settery usunięte
          isLoading={isSupportRequestLoading}
          statusMessage={supportStatusMessage}
          currentHistoryId={currentHistoryIdForSupport}
          aiModifiedHistoryId={aiModifiedHistoryIdForSupport}
          previousVersionIdForAi={previousVersionIdForAiSupport}
          // setIsAiProcessing // Już niepotrzebny, ClientOrderPanel zarządza AiProcessingOverlay
        />
      )}
      
      {/* Globalny overlay dla operacji AI, kontrolowany przez ClientOrderPanel */}
      {isAiSupportProcessing && <AiProcessingOverlay />}

        </>
      )}

      {/* Renderuj popup błędu, jeśli ładowanie się nie powiodło (używamy isLoading z hooka) */}
      {!isLoading && !order && popupConfig?.type === 'error' && (
        <Popup config={popupConfig} onClose={hidePopup} />
      )}
      {/* Komunikat, jeśli ładowanie zakończone, ale brak zamówienia i brak błędu (używamy isLoading z hooka) */}
       {!isLoading && !order && !popupConfig && (
         <p>Nie udało się załadować danych zamówienia.</p>
       )}
      </div>
    </>
  );

  // --- Nowa funkcja obsługi przycisku "Zapisz i wyślij link" ---
  async function handleSaveAndSendLink() {
    if (!order || isSavingAndSendingLink) return;

    const clientEmail = order.customOrderId;
    const panelLink = window.location.href; // Pobieramy aktualny link do panelu

    if (!clientEmail) {
      // Jeśli nie ma emaila, pokaż popup z prośbą o jego podanie
      showPopup({
        title: "Podaj adres e-mail",
        message: "Aby wysłać link do panelu, potrzebujemy Twojego adresu e-mail.",
        type: 'confirm', // Używamy typu confirm, ale z polem input
        showInput: true, // Dodajemy flagę do wyświetlenia inputu w Popup.js
        inputPlaceholder: "Twój adres e-mail",
        confirmText: "Zapisz i wyślij",
        cancelText: "Anuluj",
        onConfirm: async (enteredEmail) => {
          if (!enteredEmail || !/\S+@\S+\.\S+/.test(enteredEmail)) {
            showPopup({ title: "Nieprawidłowy e-mail", message: "Podaj poprawny adres e-mail.", type: 'error' });
            return; // Nie zamykaj poprzedniego popupa, jeśli email jest niepoprawny
          }
          hidePopup(); // Zamknij popup z inputem
          await saveEmailAndRunTrigger(enteredEmail, panelLink);
        },
        onCancel: hidePopup
      });
    } else {
      // Jeśli email jest, od razu uruchom trigger
      await saveEmailAndRunTrigger(clientEmail, panelLink);
    }
  }

  // --- Funkcja pomocnicza do zapisu emaila (jeśli trzeba) i uruchomienia triggera ---
  async function saveEmailAndRunTrigger(emailToUse, panelLink) {
    setIsSavingAndSendingLink(true);
    let emailSaved = false;

    try {
      // Sprawdź, czy email się zmienił lub go nie było i trzeba go zapisać
      if (emailToUse !== order.customOrderId) {
        const url = `${backendUrl}/client/orders/${publicKey}`;
        console.log("[ClientOrderPanel] saveEmailAndRunTrigger => PATCH email =>", url);
        const res = await fetch(url, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ customOrderId: emailToUse }) // Zapisujemy nowy email
        });

        if (!res.ok) {
          throw new Error(`Błąd zapisu adresu e-mail (status=${res.status})`);
        }
        const result = await res.json();
        console.log("[ClientOrderPanel] saveEmailAndRunTrigger => email saved result=", result);
        // Zaktualizuj stan lokalny nowym emailem
        setOrder(prevOrder => ({ ...prevOrder, customOrderId: emailToUse }));
        emailSaved = true;
      }

      // Uruchom trigger 'zapisz_panel' używając funkcji z hooka actions
      // Zakładamy, że dodamy funkcję 'runSavePanelTrigger' do useClientOrderActions
      await actions.runSavePanelTrigger(emailToUse, panelLink);

      // Pokaż sukces tylko jeśli trigger się powiódł (obsługa błędów w runSavePanelTrigger)
      // Sukces jest teraz pokazywany wewnątrz runSavePanelTrigger w hooku actions
      // showPopup({
      //   title: "Link wysłany!",
      //   message: `Link do panelu został wysłany na adres ${emailToUse}. ${emailSaved ? 'Adres e-mail został zapisany.' : ''}`,
      //   type: 'success'
      // });

    } catch (err) {
      console.error("[ClientOrderPanel] saveEmailAndRunTrigger =>", err);
      showPopup({
        title: "Błąd",
        message: `Nie udało się ${emailSaved ? 'zapisać adresu e-mail i ' : ''}wysłać linku. Błąd: ${err.message}`,
        type: 'error'
      });
    } finally {
      setIsSavingAndSendingLink(false);
    }
  }

}
